<template>
  <v-app>
    <v-navigation-drawer permanent width="220" style="padding:0">
      <Sidebar />
    </v-navigation-drawer>
    <v-main>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

export default {
  components: { Sidebar }
}
</script>

<style>
#app {
  background: #ffffff;
  text-align: center;
}
</style>
